export default __webpack_public_path__ + "static/media/payment-error.ae84c87e.svg";